import React, { createContext, useContext, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import { Currency, Tenant } from '~types'
import useApi from '~api/api'
import { apiUrls } from '~constants'

export interface TenantContextInterface extends Tenant {
  timeDiff: number
}

const BASE_TENANT_STATE: Tenant = {
  id: 0,
  name: '',
  slug: '',
  domains: [],
  currency: {} as Currency,
  isActive: false,
  paidUntil: '',
  onTrial: false,
  ticketLogoBase64: '',
  ticketEndMessage: null,
  createdAt: '',
  locale: '',
  locales: [],
}

const TenantContext = createContext<TenantContextInterface>({} as TenantContextInterface)

export const TenantProvider = ({ children }: { children: React.ReactNode }) => {
  const api = useApi()
  const [tenantState, setTenantState] = useState<Tenant>(BASE_TENANT_STATE)

  const tenant = useQuery<Tenant>({
    queryKey: ['tenant'],
    queryFn: async () => {
      const response = await api.get<Tenant>(apiUrls.tenant())
      return response.data
    },
  })

  const timeDiff = new Date().getTimezoneOffset() / 60

  useEffect(() => {
    if (tenant.isSuccess) {
      setTenantState(tenant.data)
    }
  }, [tenant])

  return (
    <TenantContext.Provider value={{ ...tenantState, timeDiff }}>{children}</TenantContext.Provider>
  )
}

export const useTenant = () => {
  return useContext(TenantContext)
}
